import { z } from 'zod';
import { ComponentSchema, SectionSchema } from '../../models';

const ActionsNames = z.union([
    z.literal('replaceComponent'),
    z.literal('deleteComponent'),
    z.literal('addComponent'),
    z.literal('addComponentList'),
]);

export type ActionNames = z.infer<typeof ActionsNames>;

const UpdateComponentShared = z.object({
    dashboardId: z.string({
        description: 'The id of the dashboard.',
    }),
    sectionId: z.string({
        description: 'The id of the section.',
    }),
    componentId: z.string({
        description: 'The id of the component.',
    }),
});

export const ReplaceComponentSchema = UpdateComponentShared.merge(
    z.object(
        {
            component: ComponentSchema.partial(), // Just saying any for now because the schema for component is a little weird (@georgepe_dat)
            opts: z.object({
                keep: z
                    .array(
                        z
                            .string({
                                description: 'Key to persist',
                            })
                            .optional(),
                        {
                            description: 'Keys to persist.',
                        },
                    )
                    .optional(),
            }),
        },
        {
            description:
                'Replaces a component at a certain id with the provided component.',
        },
    ),
);

export type ReplaceComponent = Required<z.infer<typeof ReplaceComponentSchema>>;
